// What a key does to the home list, as pure answers the list turns into
// focus and actions. `current` is the row that has focus, or -1 for none.
// Arrows clamp at the ends rather than wrapping, as an iOS list does.

export function nextIndex(count: number, current: number, key: string): number | undefined {
  if (count === 0) return undefined;
  switch (key) {
    case 'ArrowDown': return current < 0 ? 0 : Math.min(count - 1, current + 1);
    case 'ArrowUp': return current < 0 ? count - 1 : Math.max(0, current - 1);
    case 'Home': return 0;
    case 'End': return count - 1;
    default: return undefined;
  }
}

export type RowAction = 'focus' | 'delete';

/** Enter is not here: the row's title is a button, so Enter opens it natively. */
export function rowAction(key: string): RowAction | undefined {
  if (key === 'f' || key === 'F') return 'focus';
  if (key === 'Delete' || key === 'Backspace') return 'delete';
  return undefined;
}
